import { render, staticRenderFns } from "./grazie.vue?vue&type=template&id=4f369a18&"
import script from "./grazie.vue?vue&type=script&lang=js&"
export * from "./grazie.vue?vue&type=script&lang=js&"
import style0 from "./grazie.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports